import { render, staticRenderFns } from "./HighscoreOverlay.vue?vue&type=template&id=0c2766e3&scoped=true&"
import script from "./HighscoreOverlay.vue?vue&type=script&lang=js&"
export * from "./HighscoreOverlay.vue?vue&type=script&lang=js&"
import style0 from "./HighscoreOverlay.vue?vue&type=style&index=0&id=0c2766e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2766e3",
  null
  
)

export default component.exports